import { render, staticRenderFns } from "./PublishModal.vue?vue&type=template&id=450713aa"
import script from "./PublishModal.vue?vue&type=script&lang=js"
export * from "./PublishModal.vue?vue&type=script&lang=js"
import style0 from "./PublishModal.vue?vue&type=style&index=0&id=450713aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports